const { vec4 } = require('glov/common/vmath.js');
const { spritesheetRegister } = require('glov/client/spritesheet.js');
module.exports = {
  name: 'phys',
  tiles: {
    door: 0,
    door_blue: 1,
    door_cyan: 2,
    door_indoor: 3,
    door_red: 4,
    entrance: 5,
    exit: 6,
    floor: 7,
    indoor_ceiling: 8,
    indoor_floor: 9,
    wall: 10,
    wall_bldg: 11,
    wall_bldg_trim: 12,
    wall_indoor: 13,
    wall_trim: 14
  },
  uidata: {
    rects: [
      vec4(8/1024,8/64,40/1024,40/64),
      vec4(56/1024,8/64,88/1024,40/64),
      vec4(104/1024,8/64,136/1024,40/64),
      vec4(152/1024,8/64,184/1024,40/64),
      vec4(200/1024,8/64,232/1024,40/64),
      vec4(248/1024,8/64,280/1024,40/64),
      vec4(296/1024,8/64,328/1024,40/64),
      vec4(344/1024,8/64,376/1024,40/64),
      vec4(392/1024,8/64,424/1024,40/64),
      vec4(440/1024,8/64,472/1024,40/64),
      vec4(488/1024,8/64,520/1024,40/64),
      vec4(536/1024,8/64,568/1024,40/64),
      vec4(584/1024,8/64,616/1024,40/64),
      vec4(632/1024,8/64,664/1024,40/64),
      vec4(680/1024,8/64,712/1024,40/64)
    ]
  },
  layers: undefined,
  FRAME_DOOR: 0,
  FRAME_DOOR_BLUE: 1,
  FRAME_DOOR_CYAN: 2,
  FRAME_DOOR_INDOOR: 3,
  FRAME_DOOR_RED: 4,
  FRAME_ENTRANCE: 5,
  FRAME_EXIT: 6,
  FRAME_FLOOR: 7,
  FRAME_INDOOR_CEILING: 8,
  FRAME_INDOOR_FLOOR: 9,
  FRAME_WALL: 10,
  FRAME_WALL_BLDG: 11,
  FRAME_WALL_BLDG_TRIM: 12,
  FRAME_WALL_INDOOR: 13,
  FRAME_WALL_TRIM: 14
};
spritesheetRegister(module.exports);
